import React from 'react'
import { useState, useEffect, useContext} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faComment, faCalendarDays} from "@fortawesome/free-regular-svg-icons";
import {faList, faArrowDown, faSpinner, faHourglass} from "@fortawesome/free-solid-svg-icons";
import {Popover, OverlayTrigger, Button} from 'react-bootstrap';
import { getLatestFreeQuestions } from '../../functions/api';
import { LoadingContext } from '../../partials/Context';

function ProblemsList() {
    const [latest_problems, setLatestProblems] = useState([]);
    const [page, setPage] = useState(1);
    const {loading, setLoading} = useContext(LoadingContext);

    useEffect(()=>{
            setLoading(true)
            getLatestFreeQuestions(setLatestProblems, latest_problems,  page, setLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[page])
    let list = [];

    const showMore = () => {
        setPage(page+1);
    }

    const PopoverComponent = (text) => {
    return(
        <>
        <Popover id="popover-basic">
        <Popover.Body>
            {text}
        </Popover.Body>
        </Popover>
        </>
    )
    }
    
    latest_problems.map((item, index)=> {
        const {category, created, responds_nb, problem, get_url} = item || {};
        const {icon_url, name} = category || '';
        let date = new Date(created).toLocaleDateString().split('.').join('/');
        list.push(
            <li key={index}>
                <div className="last-problem-header">
                    <div className="category-icon inline-block">
                        <img src={icon_url} alt=''></img>
                    </div>
                    <div className="inline-block">
                        <div>{name}</div>
                        <div className="inline-block ng-binding">
                            <OverlayTrigger trigger={["hover", 'hover']} placement="top" overlay={PopoverComponent('Data utworzenia pytania')}>
                            <Button className="remove-btn-styling"><FontAwesomeIcon icon={faCalendarDays}/> {date} |</Button>
                            </OverlayTrigger>
                        </div>
                        <div className="inline-block">
                            <div className="inline-block">
                                <OverlayTrigger trigger={["hover", 'hover']} placement="top" overlay={PopoverComponent(`${responds_nb>0?'Ilość odpowiedzi':'To pytanie wciąż oczekuje na odpowiedź'}`)}>
                            <Button className="remove-btn-styling">
                                <FontAwesomeIcon icon={responds_nb>0?faComment:faHourglass} />
                                {responds_nb>0?responds_nb:''}
                            </Button></OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="last-problem-content">
                    <a href={get_url}>
                        {problem.slice(0,350)}
                        <b>...więcej</b>
                    </a>
                </div>
            </li>
        )
        return list
    })


  return (
    <section className="last-problems">
    <ul>
        {list}
    </ul>
    <div className="text-center pf-actions">
                <a href="/zapytaj-prawnika/">
                    <div className="loading-btn pointer">
                        <FontAwesomeIcon icon={faList} className="icon"/>
                        <div className="loading-btn-text">Zobacz wszystkie</div>
                    </div>
                </a>

                <div className="loading-btn">
                    <FontAwesomeIcon icon={loading?faSpinner:faArrowDown} className="icon" onClick={showMore}/>
                    <div className="loading-btn-text">{loading? 'Przetwarzanie': 'Pokaż więcej'}</div>
                </div>
            </div>
    </section>
  )
}

export default ProblemsList